import { Eye, Sparkles } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';

interface ImageryCardProps {
  imagery: {
    image: string;
    meaning: string;
    ref?: string;
  };
}

export function ImageryCard({
  imagery
}: ImageryCardProps) {
  return (
    <DiscoveryCard
      isExpanded={true}
      onToggle={() => { }}
      canExpand={false}
      icon={Eye}
      header={
        <div className="flex flex-col gap-3 flex-1 min-w-0 relative z-10">
          <div className="flex items-center justify-between gap-2">
            <h4 className="text-xl font-serif font-medium tracking-tight text-foreground/90 leading-tight">
              {imagery.image}
            </h4>
            {imagery.ref && (
              <span className="text-xs font-medium text-muted-foreground bg-muted/50 px-2 py-0.5 rounded-full">
                {imagery.ref}
              </span>
            )}
          </div>
        </div>
      }
    >
      <div className="space-y-4 mt-1 relative z-10 px-1">
        <p className="text-sm text-foreground/70 font-light leading-relaxed">
          {imagery.meaning}
        </p>
      </div>
    </DiscoveryCard>
  );
}
